import { AuthStateEvent } from '@/common/constants/auth';
import { HOME_PAGE } from '@/common/constants/pages';
import { navigateTo } from '@/common/helpers/navigateTo';
import ErrorPage from '@/common/pages/ErrorPage/ErrorPage';
import Storage, { KEY_AUTH_REDIRECT_STARTED, KEY_AUTH_TOKEN, KEY_URI_AFTER_AUTH } from '@/common/services/Storage';
import AppError from '@/common/state/AppError';

function Auth() {
  const hash = new URLSearchParams(window.location.hash.substring(1))?.get('access_token');

  if (hash) {
    Storage.saveObject(KEY_AUTH_TOKEN, hash, Storage.STORAGE_LOCAL);
    Storage.removeObject(KEY_AUTH_REDIRECT_STARTED, Storage.STORAGE_SESSION);

    const redirectURI = Storage.getObject(KEY_URI_AFTER_AUTH, Storage.STORAGE_SESSION);

    Storage.removeObject(KEY_URI_AFTER_AUTH, Storage.STORAGE_SESSION);

    window.parent?.postMessage?.({ type: AuthStateEvent.Success }, window.location.origin);

    navigateTo(redirectURI || HOME_PAGE);

    return null;
  }

  window.parent?.postMessage?.({ type: AuthStateEvent.Error }, window.location.origin);

  return <ErrorPage error={AppError.createUnauthorizedError()} />;
}

export default Auth;
